const contributeIntro = {
  sections: [
    {
      title: "New to Open Source?",
      content: [
        {
          par: "Contributing to open source for the first time can be a little scary and overwhelming. AnitaB.org Open Source is here to help you get started on learning how to contribute to open source. "
        },
        {
          par: "AnitaB.org Open Source has a variety of open source projects on GitHub (https://github.com/anitab-org) for everyone to contribute. If you have never contributed to an open source project, check out each repository and try out 'First Timers Only' issues."
        },
        {
          par: "We encourage contributions of ALL kinds (content, design, coding, documentation, testing, etc) from community members. Each member has the opportunity to gain global collaboration experience working on projects with social impact and improve hard & soft skills while participating as a volunteer, mentor, writer, coder, designer, app tester, and more!"
        },
        {
          par: "Here are some list of contributions to any of the AnitaB.org Open Source projects, for example: create GitHub issues regarding an open source project, work on/ debug a project issue, update project documentation, create organization content, create/test a pull request, produce mockups for websites/ applications/ organization promotional material, research on UI/UX improvements and accessibilty features, etc."
        },
        {
          par:
            'Each active repository has an individual stream on <a href ="https://anitab-org.zulipchat.com" style="color:#2980b9; text-decoration:none">Zulip</a>. If you have any questions and not sure how to get started, please ping us on <a href ="https://anitab-org.zulipchat.com" style="color:#2980b9; text-decoration:none">Zulip</a> and we are happy to help!'
        }
      ]
    }
  ]
}
export default contributeIntro;
